import React, { useContext, useState } from 'react';

import { InfoContext } from '../../context';
import { useOutsideClick } from '../../helpers/useOutsideClick';
import { useUserMenuItems } from './useUserMenuItems';
import { Dropdown } from '../Dropdown/Dropdown';
import { OutOfOfficeModal } from '../OutOfOffice/OutOfOfficeModal';

/*
 * bynder-platform/bynder/views/navigation/includes/menu.cfm: 71
 */
export function UserMenu() {
	const { general } = useContext(InfoContext);
	const menuItems = useUserMenuItems();

	const [isPinned, setIsPinned] = useState(false);
	const [isHover, setIsHover] = useState(false);

	const avatarStyle = general.userPictureUrl
		? { backgroundImage: `url(${general.userPictureUrl})` }
		: {};

	const onPinned = () => {
		setIsPinned((prev) => !prev);
	};

	const onOutsideClick = () => {
		setIsPinned(false);
	};

	const refButton = React.useRef<HTMLLIElement>(null);
	useOutsideClick(refButton, onOutsideClick);

	const onMouseEnter = () => {
		setIsHover(true);
	};

	const onMouseLeave = () => {
		setIsHover(false);
	};

	const onItemClick = () => {
		setIsPinned(true);
	};

	const isOpen = isHover || isPinned;

	return (
		<>
			<li
				ref={refButton}
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
				className={`touch-block ${isPinned ? 'hover' : ''}`}
			>
				<a
					onClick={onPinned}
					href="#"
					title={general.userName}
					className="admin-dropdown profile"
				>
					<div className="avatar" style={avatarStyle} />
					{general.userName}
				</a>

				{isOpen && <Dropdown items={menuItems} onItemClick={onItemClick} />}
			</li>

			<OutOfOfficeModal />
		</>
	);
}
